/**
 * ios-tab-bar — last child of a scrolling tab screen: keeps the floating iOS
 * bar's height free under the content, so the last item scrolls clear of it.
 * A spacer, not padding: WebKit ignores a scroll container's padding-bottom.
 * `--tab-bar-inset` only exists in the iOS layout: 0 high on Android and web.
 */
export default function TabBarSpacer() {
  return <div aria-hidden="true" className="tw:h-[var(--tab-bar-inset,0px)] tw:shrink-0" />;
}
